function setDefaultsImpl(_a) {
  var _b = _a.allowIcannDomains,
      allowIcannDomains = _b === void 0 ? true : _b,
      _c = _a.allowPrivateDomains,
      allowPrivateDomains = _c === void 0 ? false : _c,
      _d = _a.detectIp,
      detectIp = _d === void 0 ? true : _d,
      _e = _a.extractHostname,
      extractHostname = _e === void 0 ? true : _e,
      _f = _a.mixedInputs,
      mixedInputs = _f === void 0 ? true : _f,
      _g = _a.validHosts,
      validHosts = _g === void 0 ? null : _g,
      _h = _a.validateHostname,
      validateHostname = _h === void 0 ? true : _h;
  return {
    allowIcannDomains: allowIcannDomains,
    allowPrivateDomains: allowPrivateDomains,
    detectIp: detectIp,
    extractHostname: extractHostname,
    mixedInputs: mixedInputs,
    validHosts: validHosts,
    validateHostname: validateHostname
  };
}

var DEFAULT_OPTIONS = setDefaultsImpl({});
export function setDefaults(options) {
  if (options === undefined) {
    return DEFAULT_OPTIONS;
  }

  return setDefaultsImpl(options);
}